import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
/**
 * An empty state that offers a way out (§6): an icon, a title, one line, and the action
 * that fills the space. `plain` drops the card for use inside one (a card inside a card
 * is banned, §9).
 */
export function EmptyState({ icon, title, description, action, secondaryAction, plain = false, compact = false, }) {
    const body = (_jsxs(Stack, { role: "status", spacing: compact ? 1 : 1.5, sx: { alignItems: 'center', textAlign: 'center', py: compact ? 2 : 5, px: 3 }, children: [icon && (_jsx(Box, { "aria-hidden": "true", sx: {
                    width: compact ? 36 : 44,
                    height: compact ? 36 : 44,
                    borderRadius: '50%',
                    display: 'grid',
                    placeItems: 'center',
                    bgcolor: 'action.hover',
                    color: 'text.secondary',
                    '& svg': { fontSize: compact ? 18 : 22 },
                }, children: icon })), _jsxs(Box, { children: [_jsx(Typography, { variant: "h5", component: "p", sx: { textWrap: 'balance' }, children: title }), description && (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 0.5, maxWidth: '46ch', textWrap: 'pretty' }, children: description }))] }), _jsxs(Stack, { direction: { xs: 'column', sm: 'row' }, spacing: 1, sx: { alignItems: 'center', pt: 0.5 }, children: [action, secondaryAction] })] }));
    return plain ? body : _jsx(Card, { children: body });
}
//# sourceMappingURL=empty-state.js.map